import React, { useEffect, useState } from 'react';
import Chart, {
  Series,
  ArgumentAxis,
  ValueAxis,
  Export,
  CommonSeriesSettings,
  Tooltip,
  Legend,
} from 'devextreme-react/chart';
import DateFilter from '@common-components/date-filter/DateFilter';
import DateRange from '@common-components/date-range/DateRange';
import { Button } from 'devextreme-react/button';
import { useFetch } from '@hooks/useStatApi';
import STATISTICS_API from 'api/statisticsApi';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Popup } from 'devextreme-react/popup'; // Import Popup for modal
import { compose } from '@reduxjs/toolkit';


function processInput(input) {
  if (input === 0) {
    // Return a random decimal from 0 to 9
    return Math.random() * 9;
  } else {
    // Return the input unchanged
    return Math.random() * 9;
  }
}


const data = [
  { range: '0.1 – 10 cm²', set1: 5, set2: 8, set3: 6 },
  { range: '10.1 – 20 cm²', set1: 10, set2: 12, set3: 11 },
  { range: '20.1 – 30 cm²', set1: 15, set2: 18, set3: 13 },
  { range: '30.1 – 40 cm²', set1: 12, set2: 17, set3: 14 },
  { range: '40.1 – 50 cm²', set1: 14, set2: 16, set3: 15 },
  { range: '50.1 – 60 cm²', set1: 11, set2: 13, set3: 10 },
  { range: '60.1 – 70 cm²', set1: 8, set2: 9, set3: 7 },
  { range: '70.1 – 80 cm²', set1: 6, set2: 5, set3: 4 },
  { range: '80.1 – 90 cm²', set1: 4, set2: 3, set3: 2 },
  { range: '>90.1 cm²', set1: 2, set2: 1, set3: 1 },
];

function GroupedBarChart({ batchNo, type = {}, supplierId: supplierIdProp, batchId = {}, sDate, eDate, filter }) {

  const today = dayjs().startOf('day');
  const oneWeekAgo = today.subtract(1, 'week');
  const supplierId = supplierIdProp || localStorage.getItem('supplierId');
  const shouldFetch = supplierId !== null; // will be null initially, but maybe undefined is also meaningful
  const [mFilter, setMfilter] = useState()
  const [isModalVisible, setIsModalVisible] = useState(false); // State to control modal visibility

  const [dateRange, setDateRange] = useState(eDate ? `${sDate} - ${eDate}` : `${oneWeekAgo.format('YYYY-MM-DD')} - ${today.format('YYYY-MM-DD')}`);
  const [selectedFilter, setSelectedFilter] = useState(filter ? filter : '1W');
  const batchID = useSelector((state) => state.overview.batchId);
  const handleRedirect = () => {
    setIsModalVisible(true); // Show the modal instead of opening a new tab
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const [startDate, endDate] = dateRange
    ? dateRange.split(' - ').map(date => dayjs(date, 'YYYY-MM-DD').format('YYYY-MM-DD'))
    : [null, null];
  const params = {

    startDate,
    endDate,
    supplierId,
  };

  const { data: volume, loading: isVolumeLoading, refetch } = useFetch(
    "fetchWeights",
    STATISTICS_API.getVolumeStats,
    (!batchNo && shouldFetch) ? params : null

  );

  const { data: volumeBatch, loading: isVolumeLoadingBatch, } = useFetch(
    "fetchWeightsbatch",
    STATISTICS_API.getVolumeStatsByBatch,
    batchNo ? { batchNo, startDate, endDate } : null

  );

  const handleQuickFilter = (filter) => {
    setSelectedFilter(filter);
    setMfilter(filter)
    const today = dayjs().startOf('day'); // Ensure it starts from today

    let fromDate = today.format('YYYY-MM-DD'); // Default to today
    switch (filter) {
      case '1W': fromDate = today.subtract(1, 'week').format('YYYY-MM-DD'); break;
      case '1M': fromDate = today.subtract(1, 'month').format('YYYY-MM-DD'); break;
      case '1Q': fromDate = today.subtract(3, 'month').format('YYYY-MM-DD'); break;
      case '1Y': fromDate = today.subtract(1, 'year').format('YYYY-MM-DD'); break;
      case '2Y': fromDate = today.subtract(2, 'year').format('YYYY-MM-DD'); break;
      default: break;
    }

    console.log(`Filter: ${filter}, From: ${fromDate}, To: ${today.format('YYYY-MM-DD')}`);
    setDateRange(`${fromDate} - ${today.format('YYYY-MM-DD')}`);
  };
  useEffect(() => {
    if (dateRange) refetch();
  }, [dateRange, refetch]);

  console.log(volume, 'volume')

  return (
    <>
      <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-4 mb-4">
        <div>
          <p className="mb-0 text-xl font-medium">Defect Distribution <span className='text-[12px]'> (Top 10 Sizes)</span></p>
        </div>
        <div>
          <DateFilter mFilter={mFilter} onFilterChange={handleQuickFilter} selectedFilter={selectedFilter} />

        </div>
        <div className="flex justify-between items-center">
          <DateRange onDateChange={(newRange) => {
            setDateRange(newRange);
            setSelectedFilter(null); // <--- RESET selectedFilter
          }} dateRange={dateRange} />

          {
            type != "full" ?
              <Button onClick={handleRedirect} className="ms-2"
                icon="fullscreen"
              />
              : null}

        </div>
      </div>
      <>
        {
          (volumeBatch?.data?.length > 0 || volume?.data?.length > 0) ? (
            <Chart
              dataSource={
                (volumeBatch?.data?.length > 0
                  ? volumeBatch?.data
                  : volume?.data?.length > 0
                    ? volume?.data
                    : []
                )
                  .filter(item =>
                    item.rawLargestGaping?.count ||
                    item.rawLargestMelaninSpot?.count ||
                    item.rawLargestBloodSpot?.count ||
                    item.grownSkinWounds?.count ||
                    item.redSkinWounds?.count ||
                    item.whiteSkinWounds?.count
                  )
                  .map(item => ({
                    range: item.filletSize,
                    set1: item.rawLargestGaping?.count,
                    set2: item.rawLargestMelaninSpot?.count,
                    set3: item.rawLargestBloodSpot?.count,
                    set4: item.grownSkinWounds?.count,
                    set5: item.redSkinWounds?.count,
                    set6: item.whiteSkinWounds?.count,
                  }))
              }
              rotated={false}>
              <CommonSeriesSettings argumentField="range" type="bar" />
              <Series valueField="set1" name="Gaping" color="#35c759" />
              <Series valueField="set2" name="Melanin" color="#ffcc00" />
              <Series valueField="set3" name="Blood Spot" color="#66c2ff" />
              <Series valueField="set4" name="Grown Skin Wounds" color="#6155f5" />
              <Series valueField="set5" name="Red Skin Wounds" color="#ff373c" />
              <Series valueField="set6" name="White Skin Wounds" color="#ad805e" />
              <ArgumentAxis 
                title="Pieces Size Range"
                label={{
                  customizeText: (arg) => {
                    // Parse the label to extract length and width from "60.50 - 22.10 cm"
                    let length = arg.value;
                    let width = arg.value;
                    if (typeof arg.value === "string" && arg.value.includes('-')) {
                      const parts = arg.value.split('-').map(s => s.trim());
                      // Extract number from each part
                      const lengthMatch = parts[0].match(/[\d.]+/);
                      const widthMatch = parts[1] ? parts[1].match(/[\d.]+/) : null;
                      length = lengthMatch ? lengthMatch[0] : parts[0];
                      width = widthMatch ? widthMatch[0] : (parts[1] || parts[0]);
                    }
                    return `<span title="Length: ${length} - Width: ${width}">${arg.value}</span>`;
                  },
                  customizeHint: (arg) => {
                    let length = arg.value;
                    let width = arg.value;
                    if (typeof arg.value === "string" && arg.value.includes('-')) {
                      const parts = arg.value.split('-').map(s => s.trim());
                      const lengthMatch = parts[0].match(/[\d.]+/);
                      const widthMatch = parts[1] ? parts[1].match(/[\d.]+/) : null;
                      length = lengthMatch ? lengthMatch[0] : parts[0];
                      width = widthMatch ? widthMatch[0] : (parts[1] || parts[0]);
                    }
                    return `Length: ${length} - Width: ${width}`;
                  }

                }}
              
              />
        
              <ValueAxis title="" />
              <Legend
                verticalAlignment="bottom"
                horizontalAlignment="center"

              />
              <Tooltip
                enabled={true}
                customizeTooltip={(pointInfo) => ({
                  text: `${pointInfo.seriesName}: ${pointInfo.value}`,
                })}
              />
              <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="Weight-chart" />

            </Chart>
          ) : (
            <div className="flex justify-center items-center h-96">
              <p className="no-data-text">No Data Found</p>
            </div>
          )
        }
      </>
      <Popup
        visible={isModalVisible}
        onHiding={closeModal}
        dragEnabled={true}
        closeOnOutsideClick={true}
        showTitle={true}
        title="Defect Distribution (Top 10 Sizes)"
        width="90%"
        height="90%"
      >
        <div className='custom-graphs'>
          <div className="lg:flex flex-col lg:flex-row space-y-3 lg:space-y-0 items-center justify-between gap-">
            <div>
              <DateFilter
                mFilter={mFilter}
                onFilterChange={handleQuickFilter}
                selectedFilter={selectedFilter}
              />
            </div>
            <div>
              <DateRange
                onDateChange={(newRange) => {
                  setDateRange(newRange);
                  setSelectedFilter(null); // Reset selectedFilter
                }}
                dateRange={dateRange}
              />
            </div>
          </div>
          <>
            {
              (volumeBatch?.data?.length > 0 || volume?.data?.length > 0) ? (
                <Chart
                  height={600}
                  dataSource={
                    (volumeBatch?.data?.length > 0
                      ? volumeBatch?.data
                      : volume?.data?.length > 0
                        ? volume?.data
                        : []
                    )
                      .filter(item =>
                        item.rawLargestGaping?.count ||
                        item.rawLargestMelaninSpot?.count ||
                        item.rawLargestBloodSpot?.count ||
                        item.grownSkinWounds?.count ||
                        item.redSkinWounds?.count ||
                        item.whiteSkinWounds?.count
                      )
                      .map(item => ({
                        range: item.filletSize,
                        set1: item.rawLargestGaping?.count,
                        set2: item.rawLargestMelaninSpot?.count,
                        set3: item.rawLargestBloodSpot?.count,
                        set4: item.grownSkinWounds?.count,
                        set5: item.redSkinWounds?.count,
                        set6: item.whiteSkinWounds?.count,
                      }))
                  }
            rotated={false}>
                  <CommonSeriesSettings argumentField="range" type="bar" />
                  <Series valueField="set1" name="Gaping" color="#35c759" />
                  <Series valueField="set2" name="Melanin" color="#ffcc00" />
                  <Series valueField="set3" name="Blood Spot" color="#66c2ff" />
                  <Series valueField="set4" name="Grown Skin Wounds" color="#6155f5" />
                  <Series valueField="set5" name="Red Skin Wounds" color="#ff373c" />
                  <Series valueField="set6" name="White Skin Wounds" color="#ad805e" />
                  <ArgumentAxis 
                    title="Pieces Size Range"
                    label={{
                      customizeText: (arg) => {
                        // Parse the label to extract length and width from "60.50 - 22.10 cm"
                        let length = arg.value;
                        let width = arg.value;
                        if (typeof arg.value === "string" && arg.value.includes('-')) {
                          const parts = arg.value.split('-').map(s => s.trim());
                          // Extract number from each part
                          const lengthMatch = parts[0].match(/[\d.]+/);
                          const widthMatch = parts[1] ? parts[1].match(/[\d.]+/) : null;
                          length = lengthMatch ? lengthMatch[0] : parts[0];
                          width = widthMatch ? widthMatch[0] : (parts[1] || parts[0]);
                        }
                        return `<span title="Length: ${length} - width: ${width}">${arg.value}</span>`;
                      },
                      customizeHint: (arg) => {
                        let length = arg.value;
                        let width = arg.value;
                        if (typeof arg.value === "string" && arg.value.includes('-')) {
                          const parts = arg.value.split('-').map(s => s.trim());
                          const lengthMatch = parts[0].match(/[\d.]+/);
                          const widthMatch = parts[1] ? parts[1].match(/[\d.]+/) : null;
                          length = lengthMatch ? lengthMatch[0] : parts[0];
                          width = widthMatch ? widthMatch[0] : (parts[1] || parts[0]);
                        }
                        return `Length: ${length} - width: ${width}`;
                      },
                    }}
                  />
                  <ValueAxis title="" />
                  <Legend
                    verticalAlignment="bottom"
                    horizontalAlignment="center" />
                  <Tooltip
                    enabled={true}
                    customizeTooltip={(pointInfo) => ({
                      text: `${pointInfo.seriesName}: ${pointInfo.value}`,
                    })}
                  />
                  <Export enabled={true} formats={['PNG', 'PDF', 'SVG']} fileName="Weight-chart" />

                </Chart>
              ) : (
                <div className="flex justify-center items-center h-96">
                  <p className="no-data-text">No Data Found</p>
                </div>
              )
            }
          </>
        </div>
      </Popup>
    </>
  );
};



export default GroupedBarChart;
